import { atomWithRefresh } from 'jotai/utils'
import { contentServiceGet } from 'infrastructure/contentService'
import { objectValueSort } from '../../utility'
import { FlowListItem } from './types'

type FlowData = {
  completed: boolean
  details: {
    create_time: string
    description: string
    flow_id: string
  }
}

type FlowListResponse = { data: Record<string, FlowData> }

export const flowListAtom = atomWithRefresh(async () => {
  const response = await contentServiceGet<FlowListResponse>({
    path: '/content/v1/job-flow/list',
  })
  const { result, error } = response
  if (error || !result) return { error }
  const converted = Object.values(result.data)
    .sort(objectValueSort((f) => f.details.create_time))
    .reduce<FlowListItem[]>((acc, flow) => {
      return [
        ...acc,
        {
          completed: flow.completed,
          description: flow.details.description,
          flowId: flow.details.flow_id,
          createdAt: flow.details.create_time,
        },
      ]
    }, [])
    .reverse()
  return { result: converted }
})
